import { get } from "../common/dataFetch";
import { LoanSummaryDto } from "../store/taskMenuStore";
import { ResponseDto } from "../common/models/ResponseDto";

export const LoanSummary = (guid: string, interimLoanStagingId:number) => {
    return get<ResponseDto<LoanSummaryDto>>(
        `api/LoanSummary/ReadByLoanGuidAsync?loanGuid=${guid}&interimLoanStagingId=${interimLoanStagingId}` 
    );
};
